module.exports = __webpack_public_path__ + "static/media/graf-banner.b2991c10.png";